import React from "react";
import { Col, Row } from "react-bootstrap";
import Cnaqalogo from "../../../../../_resources/Images/logo.png";
import cnaBanner from "../../../../../_resources/Images/Cna2025bannerImage.png";
import { Client, ClientType } from "../../../../../_models/Client.model";
import { useReportContext } from "../../../../../_context/ReportContext";

interface ReportHeaderProps {
  client: Client;
  totalScore: string;
  reportCreateDate: string;
}

export const ReportHeader: React.FC<ReportHeaderProps> = ({
  client,
  totalScore,
  reportCreateDate,
}) => {

  const { currentViewingReport } = useReportContext()
  const area_based_scoring_types =
    process.env.REACT_APP_AREA_BASED_SCORING_TYPES?.split(",");
  const hideSectionForDomesticReports = !area_based_scoring_types?.includes(currentViewingReport.Client.Type.toString())
  const shouldShowScore = hideSectionForDomesticReports && currentViewingReport.Client.Type !== ClientType.NDIS;

  const getReportTitle = () => {
    if (currentViewingReport.Client.Type === ClientType.NDIS) {
      return "NDIS Cleaning Report";
    }
    return hideSectionForDomesticReports ? `CNA Inspection Report` : 'Job Completion Report';
  };

  return (
    <>
      <Row>
        <Col sm={12} className="d-flex align-conent-center justify-content-end">
          <h1 className="reportHeader">{getReportTitle()}</h1>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col sm={12}>
          <img src={cnaBanner} className="w-100" />
        </Col>
      </Row>
      <Row className="mt-2">
        <Col sm={6}>
          <h2 className="reportClientName">{client.Name}</h2>
        </Col>
        <Col sm={6} className="d-flex justify-content-end">
          {shouldShowScore && <span className="reportScore">{`${totalScore}%`}</span>}
        </Col>
      </Row>
      <Row className="reportAddressRow">
        <Col sm={6} className="mt-0">
          <span className="reportClientAddress">
            {`${client.Address.Line1.toUpperCase()},`}
            {client.Address.Line2 && `${client.Address.Line2.toUpperCase()},`}
            {`${client.Address.Suburb.toUpperCase()},`}
            {client.Address.Postcode}
          </span>
        </Col>
        <Col sm={6} className="d-flex justify-content-end reportScoreText">
          {shouldShowScore && <>Total Score</>}
        </Col>
      </Row>
      <Row>
        <Col>
          <small>{`Created Date : ${reportCreateDate}`}</small>
        </Col>
      </Row>

      <hr />
    </>
  );
};

